// extracted by mini-css-extract-plugin
export default {"products":"xA-z","card":"yA-z","oosMessaging":"zA-z"};